module.exports = __webpack_public_path__ + "img/icon-add.c48bba35.svg";